import { Box, Grid } from "@material-ui/core";
import { useParams } from "react-router-dom";
import CommonBreadcrumb from "src/components/Breadcrumb/CssBreadcrumb";
import PoolSelector from "src/components/Selector/PoolSelector";
import AuthorizationWrapper from "src/components/Wrapper/AuthorizationWrapper";
import { useUserContext } from "src/context/config/userContext";
import { useUserMonitoringContext } from "src/context/monitoring/userMonitoringContext";
import ButtonAddressTextField from "../ButtonAddressTextField";
import ActionUserData from "./ActionUserData";
import AssetTransformationOverview from "./AssetOverviewOverview";
import LiquidateUserData from "./LiquidateUserData";
import LiquidationHistoryOverview from "./LiquidationHistoryOverview";
import TotalValueLockedOverview from "./TotalValueLockedOverview";
import TransactionHistoryOverview from "./TransactionHistoryOverview";

export default function UserMonitoring() {
  const { pool } = useParams();
  const { role } = useUserContext();
  const { selectedAddress, setSelectedAddress } = useUserMonitoringContext();

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap">
        <CommonBreadcrumb
          config={[{ text: "analytics" }, { text: "user monitoring", link: `/user-monitoring/${pool}` }]}
        />
        <PoolSelector rootUrl="/user-monitoring" />
      </Box>
      <AuthorizationWrapper>
        {role === "admin" && (
          <ButtonAddressTextField
            style={{ marginTop: "1rem" }}
            defaultValue={selectedAddress}
            events={{ onConfirm: (value) => setSelectedAddress(value) }}
          />
        )}
        <LiquidateUserData />
        <Grid container spacing={2}>
          <Grid item lg={6} xs={12} style={{ marginTop: "1.5rem" }}>
            <AssetTransformationOverview />
          </Grid>
          <Grid item lg={6} xs={12} style={{ marginTop: "1.5rem" }}>
            <LiquidationHistoryOverview />
          </Grid>
          <Grid item lg={6} xs={12} style={{ marginTop: "1.5rem" }}>
            <TotalValueLockedOverview />
          </Grid>
          <Grid item lg={6} xs={12} style={{ marginTop: "1.5rem" }}>
            <TransactionHistoryOverview />
          </Grid>
        </Grid>
        <ActionUserData />
      </AuthorizationWrapper>
    </>
  );
}
